import React from 'react';
import styles from './ButtonSpinner.module.css';

// A small inline spinner that inherits the button's text colour (currentColor),
// so it reads correctly on both filled and outline buttons. Use inside a button
// while an async action is in flight.
const ButtonSpinner = ({ size = 14 }) => (
  <span
    className={styles.spinner}
    style={{ width: size, height: size }}
    aria-label="loading"
    role="status"
  />
);

export default ButtonSpinner;
